
/* Sweet Treat Streetwear — product detail accordions. Original product data is untouched. */
(()=>{'use strict';
const tests=[/^details\s*:?\s*-?$/i,/^pair (it|them) with\s*:?\s*-?$/i,/^why you['’]ll love (it|them)\s*:?\s*-?$/i,/^care\s*:?\s*-?/i];
const strip=s=>(s||'').replace(/[🍭💖💕💗]/gu,'').replace(/\s+/g,' ').trim();

// Display icons — original section labels remain unchanged.
const headingIcons={
  'Details':'🧵',
  'Size Guide & Measurements':'📏',
  'Care & Information':'🧺'
};

function panel(label,nodes){
  const d=document.createElement('details'),
        s=document.createElement('summary'),
        b=document.createElement('div');
  d.className='sts-accordion-item';
  s.textContent=(headingIcons[label]?headingIcons[label]+' ':'')+label;
  b.className='sts-accordion-body';
  nodes.forEach(n=>b.append(n));
  d.append(s,b);
  return d;
}

function run(root){
  if(root.dataset.stsDone)return;
  const outer=root.querySelector('[data-sts-original]');
  const host=outer&&outer.firstElementChild;
  if(!host || !host.matches('rte-formatter, .text-block'))return;
  const a=[...host.children];
  const at=tests.map(t=>a.findIndex(n=>n.tagName==='P'&&t.test(strip(n.textContent))));
  const sz=a.findIndex(n=>n.matches('table#size-guide') || !!n.querySelector('table#size-guide'));
  const [D,P,L,C]=at;
  if(D<1||P<=D||L<=P||(sz!==-1&&sz<=L)||(C!==-1&&C<=L)||(C!==-1&&sz!==-1&&C<=sz))return;
  const intro=document.createElement('div'),group=document.createElement('div');
  intro.className='sts-accordion-intro';
  group.className='sts-accordion-group';
  a.slice(0,D).forEach(n=>intro.append(n.cloneNode(true)));
  const add=(label,lo,hi,includeLabel=false)=>{
    if(lo<0||hi<=lo)return;
    const nodes=a.slice(includeLabel?lo:lo+1,hi).map(n=>n.cloneNode(true));
    if(!nodes.length)return;
    const d=panel(label,nodes);
    if(label==='Size Guide & Measurements'){
      const t=d.querySelector('table#size-guide');
      if(t){
        const scroll=document.createElement('div');
        scroll.className='sts-accordion-scroll';
        t.before(scroll);
        scroll.append(t);
      }
    }
    group.append(d);
  };
  add('Details',D,P);
  add('🍭 Pair It With',P,L);
  add("💖 Why You'll Love It",L,sz!==-1?sz:(C!==-1?C:a.length));
  if(sz!==-1)add('Size Guide & Measurements',sz-1,C!==-1?C:a.length);
  if(C!==-1)add('Care & Information',C,a.length,true);
  if(group.children.length<3)return;
  // Only replace the rendered rich text after safely constructing every panel.
  host.replaceChildren(intro,group);
  root.dataset.stsDone='1';
}
function init(){document.querySelectorAll('[data-sts-product-accordion]').forEach(run);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
